import { useContext, useMemo } from 'react';

import { XYChartDataContext } from '../context/XYChartData.context.js';
import { XYChartRectDataContext } from '../context/XYChartRectData.context.js';
import {
  RECT_VARIANT,
  type RectSeriesIdToValueScaleDomain,
  type RectSeriesToMetadata,
  type RectSeriesWithDatapoints,
} from '../types/xy-chart-internals.js';

export interface RectDataInternal {
  seriesToMetadata: RectSeriesToMetadata;
  seriesIdToValueScaleDomain?: RectSeriesIdToValueScaleDomain;
  filteredSeriesWithDatapoints: RectSeriesWithDatapoints[];
  seriesWithDatapoints: RectSeriesWithDatapoints[];
}

export const useRectData = () => {
  const context = useContext(XYChartRectDataContext);
  const genContext = useContext(XYChartDataContext);

  if (context === undefined) {
    throw new Error('useRectData must be used within a XYChartRectDataContext');
  }
  if (genContext === undefined) {
    throw new Error('useXYChartData must be used within a XYChartDataContext');
  }

  const mergedContext = useMemo(() => {
    return {
      seriesIdToValueScaleDomain: context.seriesIdToValueScaleDomain,
      seriesToMetadata: genContext.seriesToMetadata,
      filteredSeriesWithDatapoints:
        genContext.filteredSeriesWithDatapoints.filter(
          (series) => series.type === RECT_VARIANT,
        ),
      seriesWithDatapoints: genContext.seriesWithDatapoints.filter(
        (series) => series.type === RECT_VARIANT,
      ),
    };
  }, [genContext, context]);

  return mergedContext as Required<RectDataInternal>;
};
